<template>
  <d-container fluid>
    <d-row>
      <!-- Main Sidebar -->
      <top-bar :items="topbarItems" />

      <d-col class="main-content px-0" tag="main" lg="12" md="12" sm="12">
        <slot />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import getTopBarItems from '@/data/topbar-nav-items';
import TopBar from '@/components/layout/TopBar.vue';

export default {
  name: 'main-view',
  components: {
    TopBar
  },
  data() {
    return {
      topbarItems: getTopBarItems()
    };
  }
};
</script>

<style lang="scss" scoped>
.main-content {
  margin-top: 48px;
  min-height: calc(100vh - 48px);
}
</style>

